window.addEventListener('load', function () {
  if(document.getElementsByTagName('afterpay-placement').length) {
     var affterPayStyle = document.createElement( 'style' )
    affterPayStyle.innerHTML = '.afterpay-paragraph {font-size: 12px !important;}'
    document.getElementsByTagName('afterpay-placement')[0].shadowRoot.appendChild( affterPayStyle ) 
  }  
})


const addCookie = (name, value, days) => {
	let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

const getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const eraseCookie = (name) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

let firstSession = getCookie('first_session');

let secondSession = false;
if (firstSession == 'false') {
  	secondSession = true;
} else {
	addCookie('first_session', 'false', 30);
}

// if(secondSession) {
//     document.getElementById('header').classList.remove('menu-2-5-hide');
// }